import React from "react";
import { GridItem } from "@chakra-ui/react";
import { Form, Grid, TextInput } from "components";
import { useCurrentCase } from "duck";
import { getValidation, useUpdateTplo } from "./duck";

const TploForm: React.FC = () => {
  const tplo = useCurrentCase(
    ({ data }) => data.client.patient.tibialPlateauLevelingOsteotomyPlanning
  );

  const validation = React.useMemo(() => getValidation(tplo), [tplo]);

  const onChange = useUpdateTplo(tplo?._id || tplo?.fakeId || null);

  if (!tplo) {
    return null;
  }

  return (
    <Form {...validation}>
      <Form.Watcher
        defaultValues={validation.defaultValues}
        onChange={onChange}
      />
      <Grid mb={12}>
        <GridItem>
          <TextInput name="d1" label="D1" placeholder="Enter details here" />
        </GridItem>
        <GridItem>
          <TextInput name="d2" label="D2" placeholder="Enter details here" />
        </GridItem>
        <GridItem>
          <TextInput name="d3" label="D3" placeholder="Enter details here" />
        </GridItem>
        <GridItem>
          <TextInput
            name="rotationNeeded"
            label="Rotation needed"
            placeholder="Enter details here"
          />
        </GridItem>
        <GridItem>
          <TextInput
            name="initialTpa"
            label="Initial TPA"
            placeholder="Enter details here"
          />
        </GridItem>
        <GridItem>
          <TextInput
            name="postOpTpa"
            label="Post-op TPA"
            placeholder="Enter details here"
          />
        </GridItem>
        <GridItem>
          <TextInput
            name="tploBladeSize"
            label="TPLO Blade Size"
            placeholder="Enter details here"
          />
        </GridItem>
        <GridItem>
          <TextInput
            name="tploPlateSizeAndModel"
            label="TPLO Plate Size and Model"
            placeholder="Enter details here"
          />
        </GridItem>
      </Grid>
    </Form>
  );
};

export default TploForm;
